import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { HubCalendarActionCommand } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { WaterFallContainerComponent } from '../../../common/components/water.fall.container/water.fall.container.component';
import { clone } from '../../../common/extensions';
import { AuthService } from '../../../common/services/auth.service';
import { HubCustomBtn } from '../../../models/hub/hub.custom.btn';
import { HubEvent } from '../../../models/hub/hub.event';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubTour } from '../../../models/hub/hub.tour';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { HubApiService } from '../../../services/hub.api.service';
import {
  CustomBtnStore,
  EditorChoiceStore,
  HubCalendarEventsStore,
  HubCalendarPlacesStore,
  HubCalendarStore,
  ToggleStore,
  ToursStore,
} from '../../../stores/hub.calendar.store';
import { LocalStorageService } from '../../../services/localStorageService';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { MatMenuTrigger } from '@angular/material';

@Component({
  selector: 'ig-hub-calendar',
  templateUrl: './hub.calendar.component.html',
  styleUrls: ['./hub.calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HubCalendarComponent extends BaseComponent implements OnInit, AfterContentChecked {
  public hubName: string;
  public events: HubEvent[] = [];
  public places: HubPlace[] = [];
  public actionCommand: HubCalendarActionCommand;
  public isAllDataLoaded: boolean;
  public isLoading: boolean;
  public isNoContent = false;
  public tours: HubTour[];
  public featuresToggle = {
    itinerary: false,
  };
  public customBtns = new HubCustomBtn();
  public allowedCategories: string[] = [];
  public searchFields: string[] = [];

  @ViewChild('waterFallContainer')
  public waterFallContainer: WaterFallContainerComponent;
  @ViewChild('spinner')
  private spinner: PageSpinnerComponent;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private hubCalendarStore: HubCalendarStore,
    private togglesStore: ToggleStore,
    private toursStore: ToursStore,
    private customBtnStore: CustomBtnStore,
    private editorChoiceStore: EditorChoiceStore,
    private hubCalendarEventsStore: HubCalendarEventsStore,
    private hubCalendarPlacesStore: HubCalendarPlacesStore,
    private hubApiService: HubApiService,
    private customizationApiService: CustomizationApiService,
    public changeDetector: ChangeDetectorRef
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;

    localStorage.removeItem(localStorageKeys.allowedPlaceCategories);

    this.toursStore.toursCommand.takeUntil(this.isDestroyed).subscribe((tours: HubTour[]) => {
      this.tours = tours || [];
    });

    this.togglesStore.toggleCommand
      .takeUntil(this.isDestroyed)
      .subscribe((toggle: HubVisitorFeatureToggle) => {
        if (toggle) {
          this.featuresToggle.itinerary = isNullOrUndefined(toggle.itinerary)
            ? true
            : toggle.itinerary;
        }
      });

    this.customBtnStore.customBtnCommand
      .takeUntil(this.isDestroyed)
      .subscribe((btns: HubCustomBtn) => {
        this.customBtns = btns || new HubCustomBtn();
      });

    this.hubCalendarStore.actionCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: HubCalendarActionCommand) => {
        // if (!!this.actionCommand && this.actionCommand.isEventCalendar !== command.isEventCalendar) {
        //     return;
        // }
        this.showSpinner();
        this.actionCommand = clone(command);
        this.isNoContent = false;
        this.waterFallContainer.startLoading();
        this.searchOptions = {
          name: true,
          address: false,
          category: false,
          description: false,
        };
        this.searchFields = ['name'];

        console.log('command.noFilter', command.queryParams.noFilter);
        if (
          command.queryParams.noFilter &&
          !localStorage.getItem(localStorageKeys.allowedPlaceCategories)
        ) {
          this.getAllowedPlaceCategories();
        }

        if (command.isEventCalendar) {
          this.getEvents();
        } else {
          this.getPlaces();
        }
      });
  }

  public loadMore() {
    this.actionCommand.queryParams.page++;
    if (this.actionCommand.isEventCalendar) {
      this.getEvents(true);
    } else {
      this.getPlaces(true);
    }
  }

  public getEvents(isLoadMore = false) {
    this.isAllDataLoaded = false;
    this.hubApiService.getEvents(this.hubName, this.actionCommand.queryParams).subscribe((data) => {
      data = data.filter((x) => x.isApproved == this.actionCommand.queryParams.isApproved);

      if (!isLoadMore) {
        this.events = data;
      } else {
        this.events = this.events.concat(data);
      }

      this.hubCalendarEventsStore.eventsCommand.next(this.events);

      if (!data || data.length === 0) {
        this.isAllDataLoaded = true;
      }
      this.waterFallContainer.reLayout();
      if (!this.events.length) {
        this.isNoContent = true;
      }

      setTimeout(() => {
        this.hideSpinner();
      });
    });
  }

  ngAfterContentChecked() {
    this.changeDetector.detectChanges();
  }

  get isShowMoreSearchOptions(): boolean {
    return (
      !this.actionCommand.isEventCalendar && this.actionCommand.queryParams.search
      //   && this.actionCommand.queryParams.isApproved
    );
  }

  public getPlaces(isLoadMore = false) {
    this.isAllDataLoaded = false;
    // this.actionCommand.queryParams.isManuallyCreated = this.actionCommand.queryParams.isManuallyCreated;
    this.hubApiService.getPlaces(this.hubName, this.actionCommand.queryParams).subscribe((data) => {
      if (!isLoadMore) {
        this.places = data;
      } else {
        this.places = this.places.concat(data);
      }

      this.hubCalendarPlacesStore.placesCommand.next(this.places);
      if (!data || data.length === 0 || data.length < 16) {
        this.isAllDataLoaded = true;
      }
      this.waterFallContainer.reLayout();
      this.hideSpinner();

      if (!this.places.length) {
        this.isNoContent = true;
      } else {
        this.isNoContent = false;
      }
    });
  }

  public getAllowedPlaceCategories() {
    this.hubApiService.getAllowedPlaceCategories(this.hubName).subscribe((data) => {
      console.log(data);
      this.allowedCategories = data;
      localStorage.setItem(localStorageKeys.allowedPlaceCategories, data.join(','));
    });
  }

  public notAllowed(place: HubPlace) {
    return !this.allowedCategories.any((x) => place.categoryList.any((y) => x === y));
  }

  public pinEvent(event: HubEvent) {
    event.pinnedTime = new Date();
    this.events.splice(this.events.indexOf(event), 1);
    this.events.unshift(event);
    this.waterFallContainer.reLayout();
  }

  public unPinEvent(event: HubEvent) {
    this.hubApiService
      .getEvents(this.hubName, this.actionCommand.queryParams)
      .subscribe((data: Array<HubEvent>) => {
        this.events = data;
        this.waterFallContainer.reLayout();
      });
  }

  public removeEvent(event: HubEvent, isRemoveSameOwnerEvents = false) {
    this.events.splice(this.events.indexOf(event), 1);
    if (this.events && this.events.length > 0) {
      for (let i = this.events.length - 1; i >= 0; i--) {
        if (isRemoveSameOwnerEvents && this.isSameOwner(this.events[i], event)) {
          this.events.splice(i, 1);
        }
      }
    }
    this.waterFallContainer.reLayout();
  }

  private isSameOwner(event1: HubEvent, event2: HubEvent) {
    if (!event1.owner) return false;
    if (!event2.owner) return false;

    if (!event1.owner.id && !event1.owner.name) return false;
    if (!event2.owner.id && !event2.owner.name) return false;

    return (
      (event1.owner.id && event2.owner.id && event1.owner.id === event2.owner.id) ||
      (event1.owner.name && event2.owner.name && event1.owner.name === event2.owner.name)
    );
  }

  public pinPlace(place: HubPlace) {
    place.pinnedTime = new Date();
    this.places.splice(this.places.indexOf(place), 1);
    this.places.unshift(place);
    this.waterFallContainer.reLayout();
  }

  public unPinPlace(place: HubPlace) {
    this.hubApiService
      .getPlaces(this.hubName, this.actionCommand.queryParams)
      .subscribe((data: Array<HubPlace>) => {
        this.places = data;
        this.waterFallContainer.reLayout();
      });
  }

  public removePlace(place: HubPlace) {
    this.places.splice(this.places.indexOf(place), 1);
    this.waterFallContainer.reLayout();
  }

  private showSpinner() {
    this.isLoading = true;
    this.spinner.show();
  }

  private hideSpinner() {
    setTimeout(() => {
      this.isLoading = false;
      this.spinner.hide();
    });
  }

  searchOptions = {
    name: true,
    address: false,
    category: false,
    description: false,
  };
  @ViewChild('searchMenuTrigger') searchMenuTrigger: MatMenuTrigger;

  applySearchOptions(trigger: MatMenuTrigger) {
    this.searchFields = [];
    if (this.searchOptions.name) this.searchFields.push('name');
    if (this.searchOptions.address) this.searchFields.push('address');
    if (this.searchOptions.category) this.searchFields.push('category');
    if (this.searchOptions.description) this.searchFields.push('description');

    this.actionCommand.queryParams.searchFields = this.searchFields.join(',');
    this.actionCommand.queryParams.page = 1;
    trigger && trigger.closeMenu();
    this.showSpinner();
    this.getPlaces();
  }

  get hasSelectedOptions(): boolean {
    return (
      this.searchOptions.name ||
      this.searchOptions.address ||
      this.searchOptions.category ||
      this.searchOptions.description
    );
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/calendar/hub.calendar.component.ts